import React, { useState, useEffect, useContext } from 'react';
import { Layout } from 'antd';
import { get } from 'lodash';

import './style.scss';

import { ProfileContext } from 'contexts/profile';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';

const err_message = {
  403: 'We are sorry, but you do not have access to this page or resource.',
  404: 'We are sorry, but the page you were looking for was not found!',
};

export function Error() {
  const [code, setCode] = useState(0);
  const location = useLocation();
  const { pageList } = useContext(ProfileContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      pageList.length > 0 &&
      location.state &&
      pageList.some(
        (e) => e.page === get(location, 'state.prevPath', '/').split('/')[1]
      )
    ) {
      const stringified = queryString.stringify(
        get(location, 'state.parsed', {})
      );
      const prevPath = get(location, 'state.prevPath', '/');

      navigate(prevPath + '?' + stringified);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageList]);

  useEffect(() => {
    if (!location.data) {
      setCode(404);
    } else {
      setCode(location.data.code);
    }
  }, [location]);

  return (
    <Layout className="pd-cms-error main-container">
      <div className="container">
        <div className="content">
          <div className="center-object">
            <div className="image">
              <img
                src={`/img/error/${code}.png`}
                width="450"
                alt="error preview"
              />
            </div>
            <div className="errorTitle">We Are Sorry...</div>
            <div className="sub-title">{err_message[code]}</div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default { Error };
